<template>
<div class="order-reminder-form">
	<!-- Form -->
	<form @submit.prevent="save">
		<div class="modal-body">
			<!-- Date -->
			<div class="form-group">
				<label><b>{{ $t('_.date') }}</b></label>
				<input type="date" class="form-control" v-model="date" :min="minDate" required>
			</div>

			<!-- Title -->
			<div class="form-group">
				<label><b>{{ $t('_.title') }}</b></label>
				<input type="text" class="form-control" v-model="title" required>
			</div>

			<!-- Description -->
			<div class="form-group">
				<label><b>{{ $t('_.description') }}</b></label>
				<textarea rows="4" class="form-control" v-model="description"></textarea>
			</div>
		</div>

		<!-- Footer -->
		<div class="modal-footer">
			<button type="button" class="btn btn-light" @click="close">Cancel</button>
			<button
				type="submit"
				class="btn btn-primary"
				:class="{ 'is-loading': isCreating }"
				:disabled="isCreating">
				<i class="material-icons">save</i><span>{{ $t('Save') }}</span>
			</button>
		</div>
	</form>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import contactsApi from '../api/contacts';
import { dateToday } from '../lib/helper';

export default {
	name: 'OrderReminder',
	props: {
		orders: {
			type: Array,
		},
	},
	data() {
		return {
			date: '',
			title: '',
			description: '',
			isCreating: false,
			minDate: dateToday(),
		};
	},
	methods: {
		...mapActions({
		}),
		close() {
			this.$emit('close');
		},
		getParams() {
			const customerIds = JSON.stringify(this.customerIds);
			const reminderDate = this.date;
			const params = {
				customer_ids: customerIds,
				type: 'reminder',
				title: this.title,
				description: this.description,
				reminder_date: reminderDate,
			};
			return params;
		},
		save() {
			this.isCreating = true;
			const params = this.getParams();
			const callback = () => {
				this.isCreating = false;
				this.$notify({
					group: 'orders',
					title: 'Order Reminder',
					text: 'Successfully created',
					type: 'success',
				});
				this.close();
			};
			const errorCallback = () => {
				this.isCreating = false;
			};
			contactsApi.storeActivity(params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
		}),
		customerIds() {
			const customerIds = this.orders.filter(order => !!order.customer_id).map(order => order.customer_id);
			return customerIds;
		},
	},
};
</script>
